module.exports = __webpack_public_path__ + "img/icon-camera.ec1d8196.svg";